var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4.25 5.5 55.5 55.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rf",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6dc8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#86bf55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9a34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wl",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8edc2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 33) scale(1.2) translate(-35 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0 61.0 L31.0 40.0 L13.0 32.0 L13.0 53.0Z",
    fill: "#dcefc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0 61.0 L57.0 52.0 L57.0 31.0 L44.0 23.2 L31.0 40.0Z",
    fill: "url(#wl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0 40.0 L44.0 23.2 L26.0 15.2 L13.0 32.0Z",
    fill: "url(#rf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.5 L27.2 22.7 L27.2 29.7 L24.5 28.5Z",
    fill: "#cfe6b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 22.7 L31.2 21.3 L31.2 28.3 L27.2 29.7Z",
    fill: "#f4fbe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 22.7 L31.2 21.3 L28.5 20.1 L24.5 21.5Z",
    fill: "#e6eadf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0 40.0 L44.0 23.2 L57.0 31.0 L57.0 33.8 L44.0 26.0 L31.0 42.8Z",
    fill: "#4f8a2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0 32.0 L31.0 40.0 L31.0 42.8 L13.0 34.8Z",
    fill: "#5e9a34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 58.1 L39.5 43.1 L48.5 39.9 L48.5 54.9Z",
    fill: "#6aa83e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0d906090d951cdaf183459ddf1cb770e.svg";
export { ForwardRef as ReactComponent };